<template>
  <div v-if="$store.state.isUserLoggedIn">
    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      :mini-variant="user.mini"
      fixed
      app
      v-if="$store.state.user.status === 'active'"
    >
      <v-list dense>
        <v-list-tile @click.stop="changeMini()">
          <v-list-tile-action>
            <v-icon v-if="user.mini">chevron_right</v-icon>
            <v-icon v-else>chevron_left</v-icon>
          </v-list-tile-action>
        </v-list-tile>

        <template v-for="item in items">
          <v-layout
            v-if="item.heading"
            :key="item.heading"
            row
            align-center
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            v-model="item.model"
            :key="item.text"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon="keyboard_arrow_down"
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.link"
            >
              <v-list-tile-action v-if="child.icon">
                <v-tooltip v-if="user.mini" right>
                <v-icon
                  slot="activator"
                >{{ child.icon }}</v-icon>
                <span>{{ child.text }}<span v-if="child.subtext"> ({{ child.subtext }})</span></span>
                </v-tooltip>
                <v-icon v-else>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text }}
                </v-list-tile-title>
                <v-list-tile-sub-title v-if="child.subtext">
                  {{ child.subtext}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else-if="adminDisplay" :key="item.text" :to="item.link">
            <v-list-tile-action>
              <v-tooltip v-if="user.mini" right>
              <v-icon
                slot="activator"
              >{{ item.icon }}</v-icon>
              <span>{{ item.text }}</span>
              </v-tooltip>
              <v-icon v-else>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar fixed dark app color="primary" clipped-left>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <img :src="logo" height="38px">
      <v-toolbar-title class="white--text">{{ page }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-avatar>
      <v-gravatar email="troymgardner@gmail.com" />
      </v-avatar> -->
      <v-avatar>
        <img
          :src="picture"
          :alt="user.fullName + ' image'"
        >
      </v-avatar>
      <v-menu offset-y>
        <v-btn slot="activator" icon dark>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list dense>
          <v-list-tile @click.stop="qrDialog = !qrDialog">
            <v-list-tile-action>
            <v-icon>mdi-qrcode-scan</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>QR Code</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click.stop="editItem">
            <v-list-tile-action>
            <v-icon>build</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Edit Profile</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="logOut">
            <v-list-tile-action>
              <v-icon>power_settings_new</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card >
        <v-card-title>
          <span class="headline">Edit Profile</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field v-model="user.firstName" label="First Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field v-model="user.lastName" label="Last Name"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="qrDialog" max-width="500px">
      <v-card >
        <v-card-title>
          <span class="headline">QR Code</span>
        </v-card-title>

        <v-card-text>
          <v-container style="text-align: center;">
            <v-layout wrap>
              <v-flex xs12 sm12>
                <qrcode-vue :value="user.fullName" :size="size" level="H"></qrcode-vue>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <UserProfile
      :visible="showUserProfile"
      :item="profile"
      @close="closeThis"
    />
  </div>
</template>

<script>
import Api from '@/services/Api'
import QrcodeVue from 'qrcode.vue'
import UserProfile from '../forms/UserProfile'

export default {
  components: {
    QrcodeVue,
    UserProfile
  },

  data: () => ({
    showUserProfile: false,
    profile: {},
    dialog: false,
    qrDialog: false,
    drawer: null,
    size: 250,
    items: [
      { icon: 'dashboard', text: 'Dashboard', link: '/' },
      { icon: 'mdi-clock-outline', text: 'Schedule', link: '/schedule/0' },
      { icon: 'mdi-file-document-multiple', text: 'Documents', link: '/document' },
      // { icon: 'mdi-currency-usd', text: 'Purchase Orders', link: '/purchase_orders' },
      { icon: 'contacts', text: 'Members', link: '/users' },
      // { icon: 'group', text: 'Committees', link: '/committee-list' }
      {
        icon: 'arrow_downward',
        'icon-alt': 'mdi-account-group-outline',
        text: 'Committees',
        model: false,
        children: [
          { icon: 'group', text: 'Committee List', link: '/committee-list' }
          //     { icon: 'arrow_forward', text: 'Import', subtext: 'Testing this' },
          //     { icon: 'arrow_forward', text: 'Export' },
        ]
      },
      {
        icon: 'arrow_downward',
        'icon-alt': 'work',
        text: 'Applications',
        model: false,
        children: [
          // { icon: 'mdi-account-cowboy-hat', text: 'BSD', link: '/muttonbustin-list' },
          // { icon: 'mdi-cow', text: 'Cattle Drive', link: '/cattledrive-list' },
          // { icon: 'mdi-golf', text: 'Golf', link: '/muttonbustin-list' },
          // { icon: 'mdi-sheep', text: 'Mutton Bustin', link: '/muttonbustin-list' },
          // { icon: 'mdi-sheep', text: 'Mutton Bustin Championship', link: '/mbchamp-list' },
          { icon: 'mdi-cash-100', text: 'Sponsors', link: '/sponsor-list' },
          { icon: 'mdi-storefront-outline', text: 'Vendors', link: '/vendor-list' }
        ]
      },
      { icon: 'speaker_notes', text: 'Texting', link: '/texting', admin: true },
      { icon: 'settings', text: 'Settings', link: '/settings', admin: true }
      // { icon: 'calendar_today', text: 'Calendar', link: '/calendar' },
      // { icon: 'mdi-dog', text: 'Animals 2', link: '/table3' },
      // { icon: 'child_care', text: 'Animals 3', link: '/table4' },
      // { icon: 'settings', text: 'Settings', admin: true },
      // { icon: 'help', text: 'Help' }
    ],
    configs: [
      { icon: 'contacts', title: 'Edit Profile', action: 'editItem' },
      { icon: 'power_settings_new', title: 'Logout', action: 'logOut' }
    ]
  }),

  props: {
    source: String
  },

  beforeMount () {
    if (this.$store.state.isUserLoggedIn) {
      this.getCommittees()
    }
  },

  computed: {
    user () {
      return this.$store.state.user
    },
    page () {
      return this.$store.state.currentPage
    },
    logo () {
      return '/static/img/logo.png'
    },
    picture () {
      return process.env.API_URL + '/images/members/' + this.$store.state.user.image
    },
    adminDisplay () {
      // console.log('item', this.items.admin)

      if (!this.items.admin) {
        return true
      } else if (this.items.admin && this.$store.state.isAdmin) {
        return true
      } else {
        return false
      }
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },

    qrDialog (val) {
      val || this.close()
    }
  },

  methods: {
    editItem () {
      this.profile = this.$store.state.user
      this.showUserProfile = true
    },

    async getCommittees () {
      try {
        const response = await Api().get('users_committees/' + this.$store.state.user.id)
        const committees = response.data

        for (let i = 0; i < committees.length; i++) {
          if (committees[i].year === this.$store.state.currentYear) {
            let committeeItem = {
              icon: 'arrow_forward',
              text: committees[i].name,
              subtext: committees[i].title,
              link: '/committees/' + committees[i].code + '/' + this.$store.state.currentYear
            }

            this.items[4].children.push(committeeItem)
          }
        }
      } catch (error) {
        if (error.response.status === 403) {
          this.$store.dispatch('setToken', null)
          this.$store.dispatch('setUser', null)
          this.$store.dispatch('setCurrentYear', 0)
          this.$router.push({
            name: 'login'
          })
        }

        // this.snackbar.message = error.response.data.error
        // this.snackbar.color = 'error'
        // this.snackbar.show = true
      }
    },

    closeThis (item) {
      this.showUserProfile = false
    },

    logOut () {
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setUser', null)
      this.$store.dispatch('setCurrentYear', 0)
      this.$router.push({
        name: 'login'
      })
    },
    changeMini () {
      this.user.mini = !this.user.mini
      this.$store.dispatch('setMini', this.user.mini)
    },

    close () {
      this.dialog = false
      this.qrDialog = false

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/navigation/NavBar.vue